/**
 * KoltPrinting "K" Logo — refined v3
 * Two angled slate bars with a metallic-copper highlight stripe.
 * The copper stripe uses an SVG linear-gradient with multi-stops to
 * imitate the play of light on foil-stamped copper.
 */
export default function KoltLogo({ className = "h-12 w-auto", showWordmark = true, variant = "default" }) {
  const slate = variant === "light" ? "#FFFFFF" : "#333F48";
  const slateShadow = variant === "light" ? "#E2E8F0" : "#1F2830";
  const subtitleColor = variant === "light" ? "rgba(255,255,255,0.65)" : "#475569";
  const wordmarkColor = variant === "light" ? "#FFFFFF" : "#1F2830";
  const uniqueId = Math.random().toString(36).slice(2, 8);

  return (
    <div className={`flex items-center gap-3 ${showWordmark ? "" : "justify-center"}`}>
      <svg
        viewBox="0 0 80 90"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="KoltPrinting logo"
      >
        <defs>
          <linearGradient id={`copper-${uniqueId}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6E3A1F" />
            <stop offset="20%" stopColor="#8B4513" />
            <stop offset="40%" stopColor="#B87333" />
            <stop offset="55%" stopColor="#E8B587" />
            <stop offset="70%" stopColor="#B87333" />
            <stop offset="100%" stopColor="#5C2E15" />
          </linearGradient>
          <linearGradient id={`slateGrad-${uniqueId}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={slate} />
            <stop offset="100%" stopColor={slateShadow} />
          </linearGradient>
        </defs>

        {/* Vertical stem */}
        <polygon points="6,4 22,4 22,86 6,86" fill={`url(#slateGrad-${uniqueId})`} />

        {/* Upper diagonal bar */}
        <polygon points="22,42 56,4 74,4 30,52" fill={`url(#slateGrad-${uniqueId})`} />

        {/* Thin metallic copper highlight stripe running through K */}
        <polygon points="30,52 74,8 78,16 34,60" fill={`url(#copper-${uniqueId})`} />

        {/* Lower diagonal bar */}
        <polygon points="22,48 30,40 76,86 58,86" fill={`url(#slateGrad-${uniqueId})`} />
      </svg>

      {showWordmark && (
        <div className="leading-none flex flex-col">
          <span
            className="font-display font-black tracking-tight text-[22px] uppercase"
            style={{ color: wordmarkColor, letterSpacing: "-0.02em" }}
          >
            KOLT
          </span>
          <span
            className="font-mono font-semibold text-[10px] tracking-[0.35em] uppercase mt-0.5"
            style={{ color: subtitleColor }}
          >
            Printing
          </span>
        </div>
      )}
    </div>
  );
}
